export default __webpack_public_path__ + "static/media/Meme_thumb.3f1e1329.jpg";